/* eslint-disable @typescript-eslint/ban-types */
import React, { ReactNode } from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";

import SubmitButton from "./SubmitButton";
import Form, { FormProps } from "./Form";
import Button from "./Button";

const style = {
  modalFooter: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
  },
};

type Props<T extends object, R extends object, E extends object> = Omit<
  FormProps<T, R>,
  "submitButton"
> & {
  title?: string;
  children: ReactNode;
  size?: string;
  open: boolean;
  onClose: () => void;
  method?: "PUT" | "POST";
};

export default function FormModal<
  T extends object,
  R extends object,
  E extends object
>(props: Props<T, R, E>) {
  const { title, children, open, size, onClose, ...rest } = props;

  return (
    <Modal isOpen={open} toggle={onClose} size={size}>
      <ModalHeader toggle={onClose}>{title}</ModalHeader>
      <ModalBody>
        <Form {...rest} submitButton={false}>
          {children}
          {/* Not using ModalFooter because then we can't wrap From in ModalBody causing
              alerts to layout incorrectly, we could address it in other ways but this
              seems alright
          */}
          <div style={style.modalFooter}>
            <Button type="button" onClick={onClose} style={{ marginRight: 6 }}>
              Close
            </Button>
            <SubmitButton new={props.new} />
          </div>
        </Form>
      </ModalBody>
    </Modal>
  );
}
